/* DENTIX — JS גלובלי */
(function () {
  'use strict';

    /* ריווח קבוע לכותרת עליונה (הפכה ל-fixed) */
      function updateHeaderSpacer() {
          var header = document.querySelector('.site-header');
              if (!header) return;
                  document.body.style.paddingTop = header.offsetHeight + 'px';
                    }
                      updateHeaderSpacer();
                        window.addEventListener('resize', updateHeaderSpacer);
                          window.addEventListener('load', updateHeaderSpacer);
                            if (document.fonts && document.fonts.ready) {
                                document.fonts.ready.then(updateHeaderSpacer);
                                  }

  /* תפריט מובייל */
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* אנימציית גילוי בגלילה */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { observer.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* כפתורי כמות */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var step = parseInt(btn.dataset.qtyChange, 10);
    var val = Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) + step);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* גלריית מוצר — החלפת תמונה ראשית */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb-src]');
    if (!thumb) return;
    var main = document.querySelector('[data-main-image]');
    if (!main) return;
    main.src = thumb.dataset.thumbSrc;
    if (thumb.dataset.thumbAlt) main.alt = thumb.dataset.thumbAlt;
    document.querySelectorAll('[data-thumb-src]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* עדכון כמות בעגלה */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.dataset.cartQty;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(input.value, 10) })
      }).then(function () { window.location.reload(); });
    });
  });

  /* הסרת פריט מהעגלה */
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(btn.dataset.cartRemove, 10), quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  /* סליידר תמונות בהירו */
  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    var slides = slider.querySelectorAll('.hero__slide');
    if (slides.length < 2) return;
    var dots = slider.querySelectorAll('[data-hero-dot]');
    var current = 0;
    var interval = (parseInt(slider.dataset.interval, 10) || 5) * 1000;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;

    function show(i) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (i + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }
    function start() {
      if (reduced) return;
      stop();
      timer = setInterval(function () { show(current + 1); }, interval);
    }
    function stop() { if (timer) clearInterval(timer); }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.heroDot, 10));
        start(); /* איפוס הטיימר אחרי בחירה ידנית */
      });
    });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });
    start();
  });

  /* מיון בעמוד קטגוריה */
  var sortSelect = document.querySelector('[data-sort-by]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
})();
